import {gql} from "@apollo/client";

export const ProfileTdas = gql`
    query ProfileTdas {
        profile {
            id
            typeDefinitionAttributeList {
                total
                typeDefinitionAttributes {
                    index
                    name
                    type
                    disabled
                    list
                    inputType
                    value
                    categories
                    optionValues {
                        value
                        name
                        translatable
                    }
                }
            }
        }
    }`